import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=5c768e35&scoped=true&"
import script from "./CheckForm.vue?vue&type=script&lang=js&"
export * from "./CheckForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=5c768e35&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c768e35",
  null
  
)

export default component.exports